<template>
    <app-autocomplete-client @coordonneesChange="setPlace"
     :btnAdd="true" @sendPoints="setPoints"/>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import * as types from '@/store/creationOpportunite/venteReseauxTempo-mutation-type';
import autocompleteClient from '@/components/filtres/autocompleteClient';

const VenteReseauxTempo = createNamespacedHelpers('venteReseauxTempo');

export default {
  name: 'autocomplete',
  components: {
    appAutocompleteClient: autocompleteClient,
  },
  data() {
    return {
      place: null,
    };
  },
  computed: {
    ...VenteReseauxTempo.mapGetters({
      showReseaux: 'showReseaux',
      getAddress: 'address',
    }),
    address: {
      get() {
        return this.getAddress;
      },
      set(value) {
        this.setFilterAddress(value);
      },
    },
  },
  watch: {
    showReseaux() {
      if (this.showReseaux) {
        this.zoom();
      }
    },
  },
  methods: {
    ...VenteReseauxTempo.mapMutations({
      setCenterReseaux: types.SET_CENTER_RESEAUX,
      setZoomCartoReseaux: types.SET_ZOOM_CARTO_RESEAUX,
      setPointsAddress: types.SET_POINTS_ADDRESS,
      setFilterAddress: types.SET_FILTER_ADDRESS,
    }),
    ...VenteReseauxTempo.mapActions({
      actionsrechercheReseaux: 'rechercheReseaux',
    }),
    setPlace(place) {
      this.place = place;
      this.address = place;
      if (this.showReseaux) {
        this.zoom();
      }
    },
    zoom() {
      if (this.place) {
        this.setCenterReseaux(this.place);
        this.setZoomCartoReseaux(11);
      }
    },
    async setPoints(points) {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      this.setPointsAddress(points);
      await this.actionsrechercheReseaux();
      loadingComponent.close();
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteReseauxTempo/filtres/autocomplete.vue